jQuery(document).ready(function($) {

       $('.podcasts--current--container').on('click',function(e){
              console.log('iframe play clicked');
              window.lintrk('track', { conversion_id: 9748018 });
       });

});